export default {
  title: 'Términos de Servicio',
  lastUpdated: 'Última actualización: 27 de noviembre de 2025',
  section1: {
    title: '1. Aceptación de los Términos',
    content1: 'Bienvenido a UmiGo. Al acceder o utilizar nuestra aplicación móvil, sitio web o cualquier servicio relacionado (colectivamente, los "Servicios"), usted acepta estar sujeto a estos Términos de Servicio ("Términos"). Si no está de acuerdo con estos Términos, no utilice nuestros Servicios.',
    content2: 'Estos Términos constituyen un acuerdo legalmente vinculante entre usted y UmiGo ("nosotros" o "nuestro"). Nos reservamos el derecho de modificar estos Términos en cualquier momento, y su uso continuado de los Servicios constituye la aceptación de cualquier cambio.'
  },
  section2: {
    title: '2. Elegibilidad',
    intro: 'Debe tener al menos 13 años (o 16 en ciertas jurisdicciones) para usar UmiGo. Al usar nuestros Servicios, usted declara y garantiza que:',
    items: [
      'Cumple con el requisito de edad mínima',
      'Tiene la capacidad legal para aceptar estos Términos',
      'Cumplirá con todas las leyes y regulaciones aplicables',
      'No ha sido previamente prohibido de usar nuestros Servicios',
      'Toda la información que proporciona es precisa y veraz'
    ]
  },
  section3: {
    title: '3. Registro de Cuenta y Seguridad',
    intro: 'Para acceder a ciertas funciones, debe crear una cuenta. Usted acepta:',
    items: [
      'Proporcionar información precisa, actual y completa durante el registro',
      'Mantener y actualizar rápidamente la información de su cuenta',
      'Mantener su contraseña segura y confidencial',
      'Notificarnos inmediatamente de cualquier acceso no autorizado o violación de seguridad',
      'Aceptar la responsabilidad de todas las actividades bajo su cuenta',
      'No compartir su cuenta con otros ni crear múltiples cuentas'
    ],
    note: 'Nos reservamos el derecho de suspender o terminar cuentas que violen estos Términos o participen en actividades sospechosas.'
  },
  section4: {
    title: '4. Conducta del Usuario y Actividades Prohibidas',
    intro: 'Usted acepta no participar en ninguna de las siguientes actividades prohibidas:',
    items: [
      'Acosar, amenazar, intimidar o intimidar a otros usuarios',
      'Publicar o compartir contenido ilegal, dañino, ofensivo o inapropiado',
      'Hacerse pasar por cualquier persona o entidad o tergiversar su afiliación',
      'Compartir contenido sexualmente explícito que involucre a menores',
      'Promover la violencia, el terrorismo o el discurso de odio',
      'Enviar spam, phishing o participar en actividades fraudulentas',
      'Violar los derechos de propiedad intelectual de otros',
      'Intentar hackear, interrumpir o comprometer nuestros Servicios',
      'Usar sistemas automatizados (bots) sin autorización',
      'Recopilar información de usuarios sin consentimiento',
      'Vender o transferir su cuenta',
      'Participar en actividades comerciales sin nuestro permiso'
    ]
  },
  section5: {
    title: '5. Contenido y Propiedad Intelectual',
    sub1: {
      title: '5.1 Su Contenido',
      content: 'Usted conserva la propiedad del contenido que crea y comparte en UmiGo ("Contenido del Usuario"). Al publicar Contenido del Usuario, nos otorga una licencia mundial, no exclusiva, libre de regalías y transferible para usar, reproducir, distribuir, modificar, adaptar, mostrar públicamente y ejecutar públicamente su Contenido del Usuario en relación con la operación y provisión de los Servicios.'
    },
    sub2: {
      title: '5.2 Nuestro Contenido',
      content: 'Todo el contenido, características y funcionalidad de los Servicios, incluidos, entre otros, texto, gráficos, logotipos, íconos, imágenes, clips de audio, clips de video y software, son propiedad de UmiGo o nuestros licenciantes y están protegidos por derechos de autor, marcas comerciales y otras leyes de propiedad intelectual.'
    },
    sub3: {
      title: '5.3 Moderación de Contenido',
      content: 'Nos reservamos el derecho de revisar, monitorear y eliminar el Contenido del Usuario que viole estos Términos o sea objetable, pero no estamos obligados a hacerlo. Podemos usar sistemas automatizados y moderadores humanos para hacer cumplir nuestras políticas de contenido.'
    }
  },
  section6: {
    title: '6. Artículos Virtuales y Compras',
    intro: 'UmiGo puede ofrecer artículos virtuales, regalos o funciones premium para comprar ("Artículos Virtuales"). Usted reconoce que:',
    items: [
      'Los Artículos Virtuales no tienen valor en el mundo real y no se pueden cambiar por efectivo',
      'Todas las compras son finales y no reembolsables, excepto según lo requiera la ley',
      'Podemos modificar, suspender o descontinuar Artículos Virtuales en cualquier momento',
      'Los Artículos Virtuales se pierden si su cuenta es terminada',
      'Usted es responsable de todos los cargos incurridos bajo su cuenta',
      'Los precios están sujetos a cambios sin previo aviso'
    ]
  },
  section7: {
    title: '7. Privacidad y Protección de Datos',
    content: 'Su privacidad es importante para nosotros. Nuestra Política de Privacidad explica cómo recopilamos, usamos y protegemos su información personal. Al usar nuestros Servicios, usted acepta nuestras prácticas de datos como se describe en la Política de Privacidad. Por favor, revísela cuidadosamente.'
  },
  section8: {
    title: '8. Comunicaciones y Notificaciones',
    intro: 'Al crear una cuenta, usted acepta recibir comunicaciones de nosotros, incluyendo:',
    items: [
      'Anuncios y actualizaciones relacionados con el servicio',
      'Alertas de seguridad y notificaciones de cuenta',
      'Comunicaciones de marketing (de las que puede optar por no participar)',
      'Respuestas de atención al cliente'
    ],
    note: 'Puede administrar sus preferencias de comunicación en la configuración de su cuenta.'
  },
  section9: {
    title: '9. Servicios y Enlaces de Terceros',
    content: 'Nuestros Servicios pueden contener enlaces a sitios web, aplicaciones o servicios de terceros. No somos responsables del contenido, prácticas de privacidad o términos de servicio de terceros. Sus interacciones con terceros son únicamente entre usted y ellos.'
  },
  section10: {
    title: '10. Descargos de Responsabilidad y Limitaciones de Responsabilidad',
    sub1: {
      title: '10.1 Disponibilidad del Servicio',
      content: 'Los Servicios se proporcionan "tal cual" y "según disponibilidad" sin garantías de ningún tipo. No garantizamos que los Servicios sean ininterrumpidos, seguros o libres de errores. Podemos modificar, suspender o descontinuar cualquier parte de los Servicios en cualquier momento sin previo aviso.'
    },
    sub2: {
      title: '10.2 Limitación de Responsabilidad',
      intro: 'En la máxima medida permitida por la ley, UmiGo y sus afiliados, funcionarios, directores, empleados y agentes no serán responsables de ningún daño indirecto, incidental, especial, consecuente o punitivo, incluidos, entre otros:',
      items: [
        'Pérdida de ganancias, datos o buena voluntad',
        'Interrupción del servicio o falla del sistema',
        'Costo de servicios sustitutos',
        'Cualquier daño que surja de su uso o incapacidad para usar los Servicios'
      ],
      note: 'Nuestra responsabilidad total no excederá la cantidad que nos pagó en los doce meses anteriores al reclamo, o $100, lo que sea mayor.'
    }
  },
  section11: {
    title: '11. Indemnización',
    intro: 'Usted acepta indemnizar, defender y eximir de responsabilidad a UmiGo y sus afiliados de cualquier reclamo, daño, pérdida, responsabilidad y gasto (incluidos los honorarios legales) que surjan de:',
    items: [
      'Su uso de los Servicios',
      'Su violación de estos Términos',
      'Su violación de cualquier derecho de otra parte',
      'Su Contenido de Usuario'
    ]
  },
  section12: {
    title: '12. Terminación',
    intro: 'Podemos suspender o terminar su cuenta y acceso a los Servicios en cualquier momento, con o sin previo aviso, por cualquier motivo, incluyendo si:',
    items: [
      'Usted viola estos Términos',
      'Su cuenta ha estado inactiva durante un período prolongado',
      'Estamos obligados a hacerlo por ley',
      'Decidimos descontinuar los Servicios'
    ],
    note: 'Puede eliminar su cuenta en cualquier momento a través de la configuración de la aplicación. Al terminar, su derecho a usar los Servicios cesará inmediatamente, y podemos eliminar sus datos de acuerdo con nuestra Política de Privacidad.'
  },
  section13: {
    title: '13. Resolución de Disputas y Arbitraje',
    sub1: {
      title: '13.1 Resolución Informal',
      content: 'Si tiene una disputa con nosotros, contáctenos primero en support@umigo.cc para intentar resolverla informalmente.'
    },
    sub2: {
      title: '13.2 Arbitraje Vinculante',
      content: 'Si no podemos resolver la disputa informalmente, cualquier disputa que surja de estos Términos o los Servicios se resolverá mediante arbitraje vinculante, excepto donde esté prohibido por la ley. Usted acepta renunciar a su derecho a un juicio con jurado o a participar en una demanda colectiva.'
    },
    sub3: {
      title: '13.3 Excepciones',
      content: 'Cualquiera de las partes puede buscar medidas cautelares en los tribunales por infracción de propiedad intelectual o acceso no autorizado a los Servicios.'
    }
  },
  section14: {
    title: '14. Ley Aplicable y Jurisdicción',
    content: 'Estos Términos se regirán e interpretarán de acuerdo con las leyes de México, sin tener en cuenta sus disposiciones sobre conflictos de leyes. Cualquier acción o procedimiento legal se llevará a cabo exclusivamente en los tribunales ubicados en la Ciudad de México, México.'
  },
  section15: {
    title: '15. Cambios a los Términos',
    content: 'Nos reservamos el derecho de modificar estos Términos en cualquier momento. Le notificaremos los cambios materiales publicando los Términos actualizados en nuestro sitio web o aplicación, y actualizando la fecha de "Última actualización". Su uso continuado de los Servicios después de que los cambios entren en vigencia constituye la aceptación de los Términos modificados.'
  },
  section16: {
    title: '16. Misceláneos',
    sub1: {
      title: '16.1 Acuerdo Completo',
      content: 'Estos Términos, junto con nuestra Política de Privacidad, constituyen el acuerdo completo entre usted y UmiGo con respecto a los Servicios.'
    },
    sub2: {
      title: '16.2 Divisibilidad',
      content: 'Si alguna disposición de estos Términos se considera inválida o inaplicable, las disposiciones restantes permanecerán en pleno vigor y efecto.'
    },
    sub3: {
      title: '16.3 Renuncia',
      content: 'Nuestro incumplimiento en hacer cumplir cualquier derecho o disposición de estos Términos no constituirá una renuncia a dicho derecho o disposición.'
    },
    sub4: {
      title: '16.4 Asignación',
      content: 'No puede asignar o transferir estos Términos sin nuestro consentimiento previo por escrito. Podemos asignar estos Términos sin restricción.'
    }
  },
  section17: {
    title: '17. Información de Contacto',
    intro: 'Si tiene alguna pregunta sobre estos Términos, contáctenos:',
    email: '<strong>Correo electrónico:</strong> support@umigo.cc',
    phone: '<strong>Teléfono:</strong> WA: +52 8 132724843',
    address: '<strong>Dirección:</strong> Av. Paseo de la Reforma 222, Ciudad de México, CDMX 06600, México'
  },
  community: {
    title: 'Directrices de la Comunidad',
    intro: 'Además de estos Términos, todos los usuarios deben seguir nuestras Directrices de la Comunidad:',
    items: [
      '<strong>Sea Respetuoso:</strong> Trate a los demás con amabilidad y respeto',
      '<strong>Manténgase Seguro:</strong> Proteja su información personal y reporte comportamientos sospechosos',
      '<strong>Sea Auténtico:</strong> Use su identidad real y no se haga pasar por otros',
      '<strong>Manténgalo Legal:</strong> No participe en actividades ilegales ni las promueva',
      '<strong>Respete la Privacidad:</strong> No comparta información privada de otros sin consentimiento',
      '<strong>Reporte Problemas:</strong> Ayúdenos a mantener una comunidad segura reportando violaciones'
    ]
  }
};
